import React from 'react';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import '../css/Zahid.css'; // Ensure the correct path to your CSS file



const cardData = [
    {
        // 1st paper title
        title: 'Title: Educational Robot European Cross-Cultural Design”',
        contentSections: [

            {
                title: "Reference: ",
                text: "A. Velentza, S. Ioannidis, N. Georgakopoulou, M. Shidujaman, and N. Fachantidis, “Educational Robot European Cross-Cultural Design,” in Human-Computer Interaction. Interaction Techniques and Novel Applications, 2021, pp. 343–354, doi: 10.1007/978-3-030-78465-2_26.",
            },
            {
                title: "Introduction:",
                text: "Educational robots have become valuable tools in various teaching applications, particularly in STEM education. However, to optimize their effectiveness, it is essential to align these robots with users' preferences in terms of appearance, functionality, and interaction. This study focuses on a participatory design approach involving stakeholders from five European countries to create an educational robot tailored to their needs.",
            },
            {
                title: "Participatory Design:",
                text: "The study engaged stakeholders, including students, teachers, parents, and professionals from different European countries. Through a participatory design process, these stakeholders contributed ideas on the robot's appearance, voice commands, and functionalities. The resulting recommendations were grouped into six categories, guiding the design of the STIMEY Robot prototype.",
            },
            {
                title: "STIMEY Robot Prototype:",
                text: "Based on the stakeholders' input, the STIMEY Robot prototype was developed. This robot was designed to be portable, combining humanoid, machinery, and cartoonish characteristics. It could change facial expressions, move its body parts, and provide vocal feedback and rewards to students.",
            },            {
                title: "Evaluation:",
                text: "The STIMEY Robot was evaluated with 92 students, aged 13 to 18, during a two-hour STEM lesson. Results indicated that students had positive attitudes and behaviors toward the robot's interactive skills and feedback. They believed the robot made STEM subjects more interesting and understandable. Additionally, students expressed increased motivation to pursue STEM careers after the robot-assisted lesson.",
            },
            {
                title: "Conclusion:",
                text: "This study highlights the importance of designing educational robots in close collaboration with stakeholders. The STIMEY Robot, developed through a cross-European participatory design process, showed promise in enhancing students' engagement with STEM subjects and fostering positive attitudes towards educational robots. Future research will expand this evaluation to more European countries to generalize the findings.",
            },

        ],
    },
// 2nd paper title
{
    title: 'Title: "I trust you more": A Behavioral Greeting Gesture Study on Social Robots for Recommendation Tasks',
    contentSections: [
        {
            title: "Reference:",
            text: "M. Shidujaman, H. Mi, and L. Jamal, “I trust you more: A Behavioral Greeting Gesture Study on Social Robots for Recommendation Tasks,” 2020 IEEE International Conference on Robotics and Automation (ICRA), Paris, France, 2020, pp. 10726-10732, doi: 10.1109/ICRA40945.2020.9196827",
        },
        {
            title: "Abstract:",
            text: "This paper investigates the impact of cultural familiarity and greeting gestures on the acceptance of recommendations made by a humanoid social robot in a cross-cultural context. The authors designed four different greeting gestures for the NAO robot based on the greeting customs of four different countries and conducted a user experiment involving participants from those countries. The results suggest that a cross-cultural design approach can enhance the likelihood of acceptance of a robot's recommendation by users with diverse cultural backgrounds.",
        },

        {
            title: "Introduction:",
            text: "The paper highlights the significance of greeting gestures in social robot behavior design and emphasizes the role of cultural differences in this context. Greetings are fundamental to human interaction, and understanding their cultural nuances is crucial for establishing connections. The study aims to explore how cultural familiarity influences users' trust in a robot's recommendations.",
        },

        {
            title: "Related Works:",
            text: "The authors discuss the importance of social interactions in various fields, including Human-Computer Interaction (HCI), Human-Machine Interaction (HMI), Human-Robot Interaction (HRI), and Robot-Robot Interaction (RRI). They stress the relevance of social robots and their potential applications. Trust and reliability are emphasized as essential factors in human-robot interactions, especially in scenarios where robots become an integral part of human environments.",
        },

        {
            title: "Experiment Design and Procedure:",
            text: "1. Hypothesis: The authors propose that a humanoid robot with a greeting gesture closely aligned with a user's native custom will improve the user's acceptance of the robot's recommendations. 2. Experiment Design: A comparative experiment is conducted, where participants are asked to answer unfamiliar questionnaires. They can choose to answer independently or seek assistance from the NAO robot. The experiment involves two conditions: Normal Greetings (NG) and Close-to-Native-Custom Greeting (CG). 3. Participants: A total of 20 participants from China, Bangladesh, Thailand, and Japan are recruited for the experiment. 4. Wizard-of-Oz Method: The experiment utilizes the Wizard-of-Oz Method to control the robot's responses when participants request recommendations.",
        },

        {
            title: "Results:",
            text: "Data Analysis: The authors analyze the acceptance rates of participants under NG and CG conditions. The results show a significant difference, supporting the hypothesis that close-to-native-custom greetings enhance users' acceptance of the robot's recommendations.",
        },

        {
            title: "Discussion:",
            text: "The authors discuss the positive impact of close-to-native-custom greetings on user enthusiasm and interest in interacting with the robot. They mention the potential importance of both physical gestures and verbal communication in establishing trust and reliability. The study identifies minor confusion among participants from different cultural backgrounds when observing greeting gestures of other nationalities. Participants express a preference for interacting with the robot using their native language.",
        },
        {
            title: "Conclusions:",
            text: "The paper concludes that a close-to-native-custom robot behavior design increases users' acceptance of robot recommendations. The authors plan to further investigate the individual effects of gestures and native language and compare their robot design with existing social humanoid robots. Overall, the study highlights the importance of cultural considerations in social robot design and provides valuable insights into enhancing user trust and acceptance in human-robot interactions.",
        },
    ],
},

{
    title: 'Title: "Application of Social Robots in Healthcare Review on Characteristics, Requirements, Technical Solutions',
    contentSections: [
        {
            title: "Reference:",
            text: "L. Ragno, A. Borboni, F. Vannetti, C. Amici and N. Cusano, “Application of Social Robots in Healthcare: Review on Characteristics, Requirements, Technical Solutions,” Sensors, vol. 23, no. 15, p. 6820, Jul. 2023, doi: 10.3390/s23156820",
        },
        {
            title: "System Design:",
            text: "",
        },

        {
            title: "Applications of Social Robots:",
            text: "The paper discusses various applications of social robots in healthcare, including their use in assisting physicians and nurses, aiding patients, and even supporting educational activities for children with neurological diseases."
        },
        
        {
            title: "Input Control Devices:",
            text: "It explains how social robots can be controlled and guided through different input control devices. These control methods vary depending on the type of robot and the nature of human-robot interaction. They may include physical or virtual joysticks, brain-computer communication headsets, voice recognition, and gesture controls."
        },
        
        {
            title: "Display and Touchscreen:",
            text: "Social robots often incorporate displays and touchscreens that allow interaction with medical personnel, children, the elderly, and individuals with impairments. These interfaces are crucial for exchanging information, preferences, and feedback, enhancing communication and user experience."
        },
        
        {
            title: "Ethical Considerations:",
            text: "The paper addresses ethical concerns related to social robots in healthcare. It discusses the potential for dehumanization in human-robot interactions and highlights the importance of ensuring that robots can recognize emotions and maintain a level of human understanding to prevent such issues."
        },
        
        {
            title: "Privacy and Security:",
            text: "Privacy and security are critical when dealing with healthcare data and personal information. The paper emphasizes the need for strong data protection measures, including encryption and blockchain technology, to ensure the privacy and security of sensitive healthcare data collected by social robots."
        },
        
        {
            title: "Guidelines for Design:",
            text: "The authors propose that the design of social robots for healthcare must be interdisciplinary, involving experts from various fields, including neuroscience, philosophy, ethics, and robotics. Guidelines for design include considering the specific needs of patients, the dynamic nature of human-robot interaction, and the importance of disease-centered design."
        },
        
        {
            title: "Modular Approach:",
            text: "The paper suggests a modular approach to designing social robots, with various functions broken down into smaller, specialized modules. This approach allows for greater flexibility and reusability in robot design."
        },
        
        {
            title: "Human Factors:",
            text: "Human factors, such as the psychology and behavior of patients and healthcare professionals, play a crucial role in the design and acceptance of social robots in healthcare. These factors must be carefully considered to ensure successful implementation."
        },
        
    ],
},

    // 3rd paper title
    {
        title: 'Title: "Initial Expectations, Interactions, and Beyond with Social Robots',
        contentSections: [
            {
                title: "Reference: ",
                text: "A. Edwards, C. Edwards, D. Westerman and P. Spence, “Initial Expectations, Interactions, and Beyond with Social Robots,” Computers in Human Behavior, vol. 90, pp. 308-314, 2019, doi: 10.1016/j.chb.2018.08.042",
            },
            {
                title: "Introduction:",
                text: "The study aims to understand how people's expectations influence their interactions with social robots. It explores whether the design or morphology of robots affects these expectations. The paper introduces the concept of the anthropocentric expectancy bias, where people tend to apply human interaction scripts to robots."
            },
            
            {
                title: "Method:",
                text: "The study uses a two-group experimental design with human and humanoid robot interaction partners. Participants are undergraduate students, and various measurements are taken at different time points during the experiment. Uncertainty, liking, and social presence are the main dependent variables assessed."
            },
            
            {
                title: "Results:",
                text: "Participants expecting to interact with a humanoid robot had similar levels of uncertainty and social presence as those expecting a human partner. However, participants anticipated lower social attraction when expecting to interact with a robot compared to a human. Actual interactions with the robot led to decreased uncertainty and increased social presence, while interactions with a human resulted in decreased social presence."
            },
            
            {
                title: "Discussion:",
                text: "The study suggests that robot design, specifically humanoid morphology, may influence people's expectations and make them more similar to interactions with humans. Expectancy violations can occur in human-robot interactions, leading to altered perceptions of the robot partner and interaction. The paper explores the possibility of hyperpersonal effects, where people feel more connected to robots after initial interactions, potentially due to their limited feedback cues. Longer interactions and further investigation into robot morphology and expectations are recommended as future research directions."
            },
            
            {
                title: "Moving Forward: A Constructivist Research Paradigm in Human-Machine Communication:",
                text: "The authors propose that the constructivist paradigm in communication research is well-suited for understanding evolving dynamics in human-robot communication. As human-robot interactions become more common, researchers should explore how expectations, stereotypes, and interpersonal constructs develop and influence these interactions. Sustained interactions with machines may impact not only human-robot interactions but also expectations and experiences in communication with other humans."
            },
            

        ],
    },

    // 4th paper title
    {
        title: 'Title: "Social Robots for Language Learning: A Review',
        contentSections: [
            {
                title: "Reference:",
                text: "R. van den Berghe, J. Verhagen, O. Oudgenoeg-Paz, S. van der Ven, and P. Leseman, “Social Robots for Language Learning: A Review,” Review of Educational Research, vol. 89, no. 2, pp. 259-295, Apr. 2019, doi: 10.3102/0034654318821286.",
            },
            {
                title: "Introduction to Robot-Assisted Language Learning (RALL):",
                text: "The paper begins by introducing the concept of robot-assisted language learning (RALL), which involves the use of robots as tutors in both first- and second-language education. This field has been rapidly evolving, with various studies exploring different languages, age groups, and aspects of language."
            },
            
            {
                title: "Scope of the Review:",
                text: "The authors review 33 studies that have investigated the use of social robots in teaching vocabulary, reading skills, speaking skills, grammar, and sign language. The goal is to examine the outcomes of these studies and discuss the possibilities and limitations of using social robots for language learning."
            },
            
            {
                title: "Learning Gains and Insights:",
                text: "The paper discusses the learning gains achieved through RALL situations. It provides insights into how social robots can effectively support language learning in different contexts. This includes assessing their impact on students' language skills and proficiency."
            },
            
            {
                title: "Motivation and Social Behavior:",
                text: "The authors highlight the importance of students' motivation in language learning and how social robots can influence it. Additionally, the paper discusses the social behavior of robots in learning situations, as it can impact the effectiveness of the learning experience."
            },
            
            {
                title: "Future Directions:",
                text: "The review concludes by pointing out directions for future research in the use of social robots in language education. It underscores the need for further exploration of this innovative approach to language learning and the potential benefits it can offer."
            },
            
            {
                title: "Keywords:",
                text: "The paper includes keywords such as 'robot-assisted language learning,' 'human-robot interaction,' 'first- and second-language learning,' 'motivation,' and 'novelty effect' to categorize and contextualize its findings."
            },
            
            {
                title: "",
                text: "",
            }
        ],
    },



   
    // Add data for more cards as needed
];

const Ashad = () => {
    return (
        <div className="l-r-main">
        <div className="litarater-review-div">
          <h1>Literature Review</h1>
        </div>
        <Row xs={1} md={2} className="g-4">
          {cardData.map((card, cardIdx) => (
            <Col key={cardIdx} className={cardIdx === cardData.length - 1 ? "last-card" : ""}>
              <div className="card-container">
                <Card className="user-custom-card">
                  <Card.Body>
                    <Card.Title>{card.title}</Card.Title>
                    {card.contentSections.map((section, sectionIdx) => (
                      <div key={sectionIdx}>
                        <h6>{section.title}</h6>
                        <p>{section.text}</p>
                      </div>
                    ))}
                  </Card.Body>
                </Card>
              </div>
            </Col>
          ))}
        </Row>

      </div>
    );
  }
export default Ashad;
